import { render } from "./AdyenPaymentModal.vue?vue&type=template&id=5566f464"
import script from "./AdyenPaymentModal.vue?vue&type=script&lang=js"
export * from "./AdyenPaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__